// import TimeoffNotificationDetail from './timeoff';
// export {
//     TimeoffNotificationDetail
// }


import { useSelector } from "react-redux";
import TimeoffNotificationDetail from './timeoff';
import ShiftSwapNotificationDetail from './shiftSwap';
import { AlertTriangle } from "lucide-react";
import { RootState } from "../../../redux/store";

const notificationComponents: Record<string, React.ElementType> = {
    TIMEOFF_APPROVAL: TimeoffNotificationDetail,
    SHIFT_SWAPPING: ShiftSwapNotificationDetail
};

const DynamicNotificationDetail: React.FC = () => {
    const categoryCode = useSelector((state: RootState) => state.notification.selectedCategoryForDetails);

    if (!categoryCode || !notificationComponents[categoryCode]) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="max-w-4xl w-full mx-auto min-h-[250px] p-6 sm:p-8 bg-red-50 border border-red-500 text-red-700 rounded-xl shadow-md flex flex-col items-center justify-center gap-3 text-center">
                    <AlertTriangle size={40} className="text-red-500" />
                    <p className="text-lg sm:text-xl font-semibold">Invalid Notification Type</p>
                    <p className="text-sm sm:text-base text-gray-700">
                        The selected notification type is not recognized. Please select a valid notification from the list.
                    </p>
                </div>
            </div>
        );        
    }
    const Component = notificationComponents[categoryCode];

    return <Component />;
};

export default DynamicNotificationDetail;
